import { Outlet } from "react-router";
const Sidebarlayout = () => {
  // if (window.location.pathname.includes("bikes24")) {
    return <Outlet />;
  // }

  
};

export default Sidebarlayout;
